import { defineMessages } from "locales/defineMessages";

// Session reports, report templates, the sessions hub and the attendance
// Excel export.
export default defineMessages({
  vi: {
    "sessionReportPage.notFound": "Không tìm thấy buổi học.",
    "sessionReportPage.title": "Báo cáo buổi học",
    "sessionReportPage.subtitle":
      "Xem toàn bộ báo cáo được gửi cho buổi học này",

    "reportTemplate.loadFailed": "Không thể tải danh sách mẫu báo cáo",
    "reportTemplate.confirmDelete": "Bạn có chắc muốn xóa mẫu báo cáo này?",
    "reportTemplate.deleteFailed": "Không thể xóa mẫu báo cáo",
    "reportTemplate.listTitle": "Mẫu báo cáo buổi học",
    "reportTemplate.create": "Tạo mẫu mới",
    "reportTemplate.empty": "Chưa có mẫu báo cáo nào.",
    "reportTemplate.default": "Mặc định",

    "reportSubmit.uploadFailed": "Tải tệp lên thất bại",

    "participantInsights.unknownUser": "Không rõ người dùng",
    "participantInsights.session": "Buổi học",
    "participantInsights.unknownClass": "Không rõ lớp",

    "excelExport.weekday.sun": "CN",
    "excelExport.weekday.mon": "T2",
    "excelExport.weekday.tue": "T3",
    "excelExport.weekday.wed": "T4",
    "excelExport.weekday.thu": "T5",
    "excelExport.weekday.fri": "T6",
    "excelExport.weekday.sat": "T7",
    "excelExport.classFallback": "Lớp học",
    "excelExport.monthProgress": "TIẾN TRÌNH THÁNG {month}/{year}",
    "excelExport.classTitle": "LỚP {name}",
    "excelExport.studentName": "TÊN HỌC VIÊN",
    "excelExport.birthYear": "NĂM SINH",
    "excelExport.rowNumber": "STT",
    "excelExport.totalSessions": "Tổng buổi",
    "excelExport.sheetClassFallback": "Lop {index}",
    "excelExport.sheetFallback": "Sheet {index}",

    "reportTemplate.fieldType.TEXT": "Văn bản",
    "reportTemplate.fieldType.NUMBER": "Số",
    "reportTemplate.fieldType.FILE": "Tệp đính kèm",
    "reportTemplate.fieldType.MULTIPLE_FILES": "Nhiều tệp đính kèm",
    "reportTemplate.nameRequired": "Tên mẫu không được để trống",
    "reportTemplate.fieldLabelRequired": "Tất cả các trường phải có tên",
    "reportTemplate.saveFailed": "Không thể lưu mẫu báo cáo",
    "reportTemplate.editTitle": "Chỉnh sửa mẫu báo cáo",
    "reportTemplate.createTitle": "Tạo mẫu báo cáo mới",
    "reportTemplate.name": "Tên mẫu",
    "reportTemplate.namePlaceholder": "VD: Báo cáo buổi tập",
    "reportTemplate.description": "Mô tả",
    "reportTemplate.descriptionPlaceholder": "Mô tả mẫu báo cáo...",
    "reportTemplate.isDefault": "Mẫu mặc định (dùng cho tất cả trung tâm)",
    "reportTemplate.fields": "Các trường báo cáo",
    "reportTemplate.addField": "Thêm trường",
    "reportTemplate.noFields":
      'Chưa có trường nào. Nhấn "Thêm trường" để bắt đầu.',
    "reportTemplate.fieldLabel": "Tên trường",
    "reportTemplate.required": "Bắt buộc",
    "reportTemplate.maxFiles": "Số file tối đa",
    "reportTemplate.update": "Cập nhật",
    "reportTemplate.submitCreate": "Tạo mẫu",

    "reportSubmit.loadTemplatesFailed": "Không thể tải mẫu báo cáo",
    "reportSubmit.deleteFileFailed": "Không thể xóa file",
    "reportSubmit.templateRequired": "Vui lòng chọn mẫu báo cáo",
    "reportSubmit.fieldRequired": 'Trường "{field}" là bắt buộc',
    "reportSubmit.submitFailed": "Không thể gửi báo cáo",
    "reportSubmit.fieldPlaceholder": "Nhập {field}...",
    "reportSubmit.chooseFile": "Chọn tệp",
    "reportSubmit.uploading": "Đang tải lên...",
    "reportSubmit.editTitle": "Chỉnh sửa báo cáo",
    "reportSubmit.createTitle": "Gửi báo cáo buổi học",
    "reportSubmit.template": "Chọn mẫu báo cáo",
    "reportSubmit.defaultSuffix": "(Mặc định)",
    "reportSubmit.generalNote": "Ghi chú chung",
    "reportSubmit.generalNotePlaceholder": "Ghi chú thêm (tùy chọn)...",
    "reportSubmit.update": "Cập nhật báo cáo",
    "reportSubmit.submit": "Gửi báo cáo",

    "reportView.sessionType.TRAINING": "Tập luyện",
    "reportView.sessionType.CLASS": "Lớp học",
    "reportView.sessionType.OPEN_GYM": "Open Gym",
    "reportView.fieldType.TEXT": "Văn bản",
    "reportView.fieldType.NUMBER": "Số",
    "reportView.fieldType.FILE": "Tệp",
    "reportView.fieldType.MULTIPLE_FILES": "Nhiều tệp",
    "reportView.excelLoadFailed": "Không thể tải tệp Excel",
    "reportView.excelReadFailed": "Không thể đọc tệp Excel",
    "reportView.loadFailed": "Không thể tải báo cáo",
    "reportView.downloadFailed": "Không thể tải tệp",
    "reportView.imageLoadFailed": "Không thể tải ảnh",
    "reportView.pdfLoadFailed": "Không thể tải tệp PDF",
    "reportView.excelEmpty": "Tệp Excel không có dữ liệu",
    "reportView.image": "Ảnh",
    "reportView.enlargeImage": "Nhấn để xem ảnh kích thước lớn",
    "reportView.pdfDocument": "Tài liệu PDF",
    "reportView.viewPdf": "Xem PDF",
    "reportView.excelSpreadsheet": "Bảng tính Excel",
    "reportView.viewSpreadsheet": "Xem bảng tính",
    "reportView.download": "Tải xuống",
    "reportView.downloadFile": "Tải tệp",
    "reportView.noTemplate": "Không có mẫu",
    "reportView.allTemplates": "Tất cả loại báo cáo",
    "reportView.filterTitle": "Lọc loại báo cáo",
    "reportView.filterHint":
      "Chọn mẫu báo cáo hoặc xem tất cả báo cáo của buổi học.",
    "reportView.emptyFiltered": "Không có báo cáo nào khớp bộ lọc.",
    "reportView.empty": "Chưa có báo cáo nào cho buổi học này.",
    "reportView.templateLabel": "Mẫu: {name}",
    "reportView.field": "Trường",
    "reportView.sheetSize": "{rows} hàng × {cols} cột",
    "reportView.sheetEmpty": "Sheet không có dữ liệu",
    "reportView.excelLoading": "Đang tải bảng tính...",

    "sessionHub.connectionFailed":
      "Không thể kết nối máy chủ. Vui lòng kiểm tra backend hoặc mạng.",
    "sessionHub.loadFailed": "Không thể tải dữ liệu buổi học",
    "sessionHub.noName": "Chưa có tên",
    "sessionHub.unassigned": "Chưa phân công",
    "sessionHub.unknownClass": "Không rõ",
    "sessionHub.rangeRequired":
      "Vui lòng chọn đầy đủ ngày bắt đầu và kết thúc.",
    "sessionHub.rangeInvalid":
      "Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc.",
    "sessionHub.allStatuses": "Tất cả trạng thái",
    "sessionHub.loading": "Đang tải màn hình buổi học...",
    "sessionHub.title": "Buổi học",
    "sessionHub.viewList": "Danh sách",
    "sessionHub.viewCalendar": "Lịch",
    "sessionHub.create": "Tạo buổi học",
    "sessionHub.class": "Lớp học",
    "sessionHub.allClasses": "Tất cả lớp học",
    "sessionHub.week": "Tuần",
    "sessionHub.prevWeek": "Tuần trước",
    "sessionHub.weekLabel": "Tuần {range}",
    "sessionHub.thisWeek": "Tuần này",
    "sessionHub.nextWeek": "Tuần sau",
    "sessionHub.emptyRange": "Không có buổi học trong khoảng ngày đã chọn.",
    "sessionHub.today": "Hôm nay",
    "sessionHub.emptyDay": "Không có buổi học.",
    "sessionHub.session": "Buổi học",
    "sessionHub.studentCount": "HV: {count}",
    "sessionHub.teacherNames": "QLL: {names}",
    "sessionHub.trainerNames": "HLV: {names}",
    "sessionHub.month": "Tháng",
    "sessionHub.pickClassTitle": "Chọn lớp học hoạt động",
    "sessionHub.pickClassHint": "Chọn lớp học để mở màn tạo buổi học mới.",
    "sessionHub.noActiveClasses": "Không có lớp học hoạt động.",
    "sessionHub.classCode": "Mã lớp: {code}",
    "sessionHub.noCode": "Chưa có mã",

    "reportsBoard.noLocation": "Chưa có địa điểm",
    "reportsBoard.noDate": "Chưa có ngày",
    "reportsBoard.noTime": "Chưa có giờ",
    "reportsBoard.noSchedule": "Chưa có lịch",
    "reportsBoard.loadFailed": "Không thể tải danh sách buổi học",
    "reportsBoard.title": "Báo cáo buổi học",
    "reportsBoard.subtitle":
      "Chọn buổi học ở cột trái để xem toàn bộ báo cáo đã gửi ở cột phải.",
    "reportsBoard.manageTemplates": "Quản lý mẫu",
    "reportsBoard.refresh": "Làm mới",
    "reportsBoard.searchPlaceholder": "Tìm theo tên/lớp/ngày",
    "reportsBoard.byClass": "Theo lớp",
    "reportsBoard.sessionList": "Danh sách buổi học",
    "reportsBoard.sessionListHint": "Bấm vào một buổi học để xem báo cáo.",
    "reportsBoard.loading": "Đang tải buổi học...",
    "reportsBoard.empty": "Không có buổi học phù hợp.",
    "reportsBoard.unknownCourse": "Không rõ khóa học",
    "reportsBoard.submittedCount": "{count}/{total} đã nộp",
    "reportsBoard.submittedReports": "Đã nộp báo cáo",
    "reportsBoard.selectSession": "Hãy chọn một buổi học để xem báo cáo.",
  },
  en: {
    "sessionReportPage.notFound": "Session not found.",
    "sessionReportPage.title": "Session reports",
    "sessionReportPage.subtitle": "All reports submitted for this session",

    "reportTemplate.loadFailed": "Failed to load report templates",
    "reportTemplate.confirmDelete": "Delete this report template?",
    "reportTemplate.deleteFailed": "Failed to delete report template",
    "reportTemplate.listTitle": "Session report templates",
    "reportTemplate.create": "New template",
    "reportTemplate.empty": "No report templates yet.",
    "reportTemplate.default": "Default",

    "reportSubmit.uploadFailed": "File upload failed",

    "participantInsights.unknownUser": "Unknown user",
    "participantInsights.session": "Session",
    "participantInsights.unknownClass": "Unknown class",

    "excelExport.weekday.sun": "Sun",
    "excelExport.weekday.mon": "Mon",
    "excelExport.weekday.tue": "Tue",
    "excelExport.weekday.wed": "Wed",
    "excelExport.weekday.thu": "Thu",
    "excelExport.weekday.fri": "Fri",
    "excelExport.weekday.sat": "Sat",
    "excelExport.classFallback": "Class",
    "excelExport.monthProgress": "PROGRESS {month}/{year}",
    "excelExport.classTitle": "CLASS {name}",
    "excelExport.studentName": "STUDENT NAME",
    "excelExport.birthYear": "BIRTH YEAR",
    "excelExport.rowNumber": "No.",
    "excelExport.totalSessions": "Total sessions",
    "excelExport.sheetClassFallback": "Class {index}",
    "excelExport.sheetFallback": "Sheet {index}",

    "reportTemplate.fieldType.TEXT": "Text",
    "reportTemplate.fieldType.NUMBER": "Number",
    "reportTemplate.fieldType.FILE": "Attachment",
    "reportTemplate.fieldType.MULTIPLE_FILES": "Multiple attachments",
    "reportTemplate.nameRequired": "Template name is required",
    "reportTemplate.fieldLabelRequired": "Every field needs a name",
    "reportTemplate.saveFailed": "Failed to save report template",
    "reportTemplate.editTitle": "Edit report template",
    "reportTemplate.createTitle": "New report template",
    "reportTemplate.name": "Template name",
    "reportTemplate.namePlaceholder": "e.g. Training session report",
    "reportTemplate.description": "Description",
    "reportTemplate.descriptionPlaceholder": "Describe this report template...",
    "reportTemplate.isDefault": "Default template (used by all centers)",
    "reportTemplate.fields": "Report fields",
    "reportTemplate.addField": "Add field",
    "reportTemplate.noFields":
      'No fields yet. Click "Add field" to get started.',
    "reportTemplate.fieldLabel": "Field name",
    "reportTemplate.required": "Required",
    "reportTemplate.maxFiles": "Max files",
    "reportTemplate.update": "Update",
    "reportTemplate.submitCreate": "Create template",

    "reportSubmit.loadTemplatesFailed": "Failed to load report templates",
    "reportSubmit.deleteFileFailed": "Failed to delete file",
    "reportSubmit.templateRequired": "Please select a report template",
    "reportSubmit.fieldRequired": '"{field}" is required',
    "reportSubmit.submitFailed": "Failed to submit report",
    "reportSubmit.fieldPlaceholder": "Enter {field}...",
    "reportSubmit.chooseFile": "Choose file",
    "reportSubmit.uploading": "Uploading...",
    "reportSubmit.editTitle": "Edit report",
    "reportSubmit.createTitle": "Submit session report",
    "reportSubmit.template": "Report template",
    "reportSubmit.defaultSuffix": "(Default)",
    "reportSubmit.generalNote": "General notes",
    "reportSubmit.generalNotePlaceholder": "Additional notes (optional)...",
    "reportSubmit.update": "Update report",
    "reportSubmit.submit": "Submit report",

    "reportView.sessionType.TRAINING": "Training",
    "reportView.sessionType.CLASS": "Class",
    "reportView.sessionType.OPEN_GYM": "Open gym",
    "reportView.fieldType.TEXT": "Text",
    "reportView.fieldType.NUMBER": "Number",
    "reportView.fieldType.FILE": "File",
    "reportView.fieldType.MULTIPLE_FILES": "Multiple files",
    "reportView.excelLoadFailed": "Failed to load Excel file",
    "reportView.excelReadFailed": "Failed to read Excel file",
    "reportView.loadFailed": "Failed to load reports",
    "reportView.downloadFailed": "Failed to download file",
    "reportView.imageLoadFailed": "Failed to load image",
    "reportView.pdfLoadFailed": "Failed to load PDF file",
    "reportView.excelEmpty": "The Excel file has no data",
    "reportView.image": "Image",
    "reportView.enlargeImage": "Click to view full size",
    "reportView.pdfDocument": "PDF document",
    "reportView.viewPdf": "View PDF",
    "reportView.excelSpreadsheet": "Excel spreadsheet",
    "reportView.viewSpreadsheet": "View spreadsheet",
    "reportView.download": "Download",
    "reportView.downloadFile": "Download file",
    "reportView.noTemplate": "No template",
    "reportView.allTemplates": "All report types",
    "reportView.filterTitle": "Filter by report type",
    "reportView.filterHint":
      "Pick a report template or view all reports for this session.",
    "reportView.emptyFiltered": "No reports match this filter.",
    "reportView.empty": "No reports for this session yet.",
    "reportView.templateLabel": "Template: {name}",
    "reportView.field": "Field",
    "reportView.sheetSize": "{rows} rows × {cols} columns",
    "reportView.sheetEmpty": "This sheet has no data",
    "reportView.excelLoading": "Loading spreadsheet...",

    "sessionHub.connectionFailed":
      "Can't reach the server. Please check the backend or your network.",
    "sessionHub.loadFailed": "Failed to load sessions",
    "sessionHub.noName": "No name",
    "sessionHub.unassigned": "Unassigned",
    "sessionHub.unknownClass": "Unknown",
    "sessionHub.rangeRequired": "Please select both a start and an end date.",
    "sessionHub.rangeInvalid":
      "The start date must be on or before the end date.",
    "sessionHub.allStatuses": "All statuses",
    "sessionHub.loading": "Loading sessions...",
    "sessionHub.title": "Sessions",
    "sessionHub.viewList": "List",
    "sessionHub.viewCalendar": "Calendar",
    "sessionHub.create": "Create session",
    "sessionHub.class": "Class",
    "sessionHub.allClasses": "All classes",
    "sessionHub.week": "Week",
    "sessionHub.prevWeek": "Previous week",
    "sessionHub.weekLabel": "Week {range}",
    "sessionHub.thisWeek": "This week",
    "sessionHub.nextWeek": "Next week",
    "sessionHub.emptyRange": "No sessions in the selected date range.",
    "sessionHub.today": "Today",
    "sessionHub.emptyDay": "No sessions.",
    "sessionHub.session": "Session",
    "sessionHub.studentCount": "Students: {count}",
    "sessionHub.teacherNames": "CM: {names}",
    "sessionHub.trainerNames": "Trainer: {names}",
    "sessionHub.month": "Month",
    "sessionHub.pickClassTitle": "Choose an active class",
    "sessionHub.pickClassHint": "Pick a class to create a new session in.",
    "sessionHub.noActiveClasses": "No active classes.",
    "sessionHub.classCode": "Class code: {code}",
    "sessionHub.noCode": "No code",

    "reportsBoard.noLocation": "No venue",
    "reportsBoard.noDate": "No date",
    "reportsBoard.noTime": "No time",
    "reportsBoard.noSchedule": "Not scheduled",
    "reportsBoard.loadFailed": "Failed to load sessions",
    "reportsBoard.title": "Session reports",
    "reportsBoard.subtitle":
      "Pick a session on the left to see all of its submitted reports on the right.",
    "reportsBoard.manageTemplates": "Manage templates",
    "reportsBoard.refresh": "Refresh",
    "reportsBoard.searchPlaceholder": "Search by name, class or date",
    "reportsBoard.byClass": "Class",
    "reportsBoard.sessionList": "Sessions",
    "reportsBoard.sessionListHint": "Click a session to view its reports.",
    "reportsBoard.loading": "Loading sessions...",
    "reportsBoard.empty": "No matching sessions.",
    "reportsBoard.unknownCourse": "Unknown course",
    "reportsBoard.submittedCount": "{count}/{total} submitted",
    "reportsBoard.submittedReports": "Reports submitted",
    "reportsBoard.selectSession": "Select a session to view its reports.",
  },
});
